import { Dispatch, SetStateAction } from "react";
import dynamic from "next/dynamic";

interface AnimationPlayerProp {
  url: string;
  //? this option is needed because when animation in rendered as
  //? in small size settin this true will slice the animtion
  //? set true if you are rendering in large size
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  AnimationRef?: Dispatch<SetStateAction<any | undefined>>;
  loop?: boolean;
  autoplay?: boolean;
  objectfit?: "contain" | "cover" | "none";
  renderer?: "svg" | "canvas";
}

//? the player will not work on ssr so it will only import on client side
const DotPlayer = dynamic(() => import("./DotPlayer"), {
  loading: () => <></>,
  ssr: false,
});

const AnimationPlayer = ({
  url,
  AnimationRef,
  autoplay = true,
  loop = true,
  objectfit = "contain",
  renderer = "svg",
}: AnimationPlayerProp) => {
  return (
    <DotPlayer
      src={url}
      AnimationRef={AnimationRef}
      autoplay={autoplay}
      loop={loop}
      objectfit={objectfit}
      renderer={renderer}
    />
  );
};

export default AnimationPlayer;
